import { useMemo } from 'react';

import { usePortfolioComponentKeys } from 'hooks/usePortfolioComponentKeys';

import { useConfigurationStore } from 'store/configurationsStore';

import { IComponentKey, IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useGetComponentKeysWithoutProjectAndContract = (): IComponentKey[] => {
    const configuration = useConfigurationStore();
    const portfolioComponentKeys = usePortfolioComponentKeys();
    return useMemo(() => [...portfolioComponentKeys, configuration.reportSummary.componentKey as keyof IHashmap], []);
};
